import { deleteMypageNovelFrontispiece } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/[frontispiece]/delete"
import { MypageNovelFrontispieceDeleteInputModel } from "../../../api/v1/mypage/novel/[novel_id]/frontispiece/[frontispiece]/DeleteInputModel"

export const deleteFrontispiece = (
  novelId: number,
  frontispieceId: number,
): Promise<void> => {
  return deleteMypageNovelFrontispiece(
    new MypageNovelFrontispieceDeleteInputModel({
      novelId,
      frontispieceId,
    }),
  )
}
